import React, { useState, useEffect } from 'react';
import {
  fetchThemeConfig,
  isUserThemeEffectDisabled,
  setUserThemeEffectDisabled,
  getAutoThemeEmojis,
  ThemeConfig,
} from './SeasonalEffect';

export default function ThemeEffectToggle() {
  const [config, setConfig] = useState<ThemeConfig | null>(null);
  const [disabled, setDisabled] = useState<boolean>(isUserThemeEffectDisabled);

  useEffect(() => {
    let isMounted = true;
    fetchThemeConfig().then((cfg) => {
      if (isMounted) setConfig(cfg);
    });

    const handleToggle = () => {
      setDisabled(isUserThemeEffectDisabled());
    };
    window.addEventListener('seasonal-effect-toggle', handleToggle);

    // Refresh every 60 seconds
    const interval = setInterval(() => {
      fetchThemeConfig().then((cfg) => {
        if (isMounted) setConfig(cfg);
      });
    }, 60000);

    return () => {
      isMounted = false;
      window.removeEventListener('seasonal-effect-toggle', handleToggle);
      clearInterval(interval);
    };
  }, []);

  if (!config || !config.enabled) return null;

  // Determine which icon to display on button
  let displayIcon = '❄️';
  if (config.mode === 'auto') {
    const auto = getAutoThemeEmojis();
    if (auto.emojis && auto.emojis.length > 0) {
      displayIcon = auto.emojis[0];
    }
  } else if (config.emojis && config.emojis.length > 0) {
    displayIcon = config.emojis[0];
  }

  const handleToggle = () => {
    const next = !disabled;
    setUserThemeEffectDisabled(next);
    setDisabled(next);
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      className={`p-1 sm:p-1.5 lg:p-2 rounded-lg shadow transition-all flex items-center justify-center relative ${
        disabled
          ? 'bg-gray-100 dark:bg-gray-800 text-gray-400 opacity-60 hover:opacity-100'
          : 'bg-white dark:bg-gray-800 hover:shadow-md text-gray-800 dark:text-gray-100'
      }`}
      aria-label="Saisonalen Effekt umschalten"
      title={
        disabled
          ? 'Saison-Effekt ist pausiert. Klicke hier, um ihn wieder zu aktivieren.'
          : 'Saison-Effekt ist aktiv. Klicke hier, um ihn für diese Sitzung zu pausieren.'
      }
    >
      <span className="text-base sm:text-lg select-none transition transform active:scale-90">
        {displayIcon}
      </span>
      {disabled && (
        <span className="absolute inset-0 flex items-center justify-center text-red-500 font-black text-sm select-none pointer-events-none">
          ／
        </span>
      )}
    </button>
  );
}
